import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { rejectInvitation, acceptInvitation, fetchUserChats } from 'modules/chats';
import InvitationCard from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.think || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    rejectInvitation: bindActionCreators(rejectInvitation, dispatch),
    acceptInvitation: bindActionCreators(acceptInvitation, dispatch),
    getChats: bindActionCreators(fetchUserChats, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InvitationCard));



// WEBPACK FOOTER //
// ./src/components/Cards/InvitationCard/container/index.js